import React, { type FC } from 'react';
import { graphql, useFragment } from 'react-relay';
import { fg } from '@atlassian/jira-feature-gating';
import type { rowsAdditionalContentRenderer_nativeIssueTable$key } from '@atlassian/jira-relay/src/__generated__/rowsAdditionalContentRenderer_nativeIssueTable.graphql';
import type { CustomComponents } from '../../../common/types.tsx';
import { useCustomComponents } from '../../../controllers/custom-components/index.tsx';

export type RowsAdditionalContentRendererProps = {
	depth: number;
	groupId?: string;
	issues: rowsAdditionalContentRenderer_nativeIssueTable$key;
};

export const RowsAdditionalContentRenderer: FC<RowsAdditionalContentRendererProps> = ({
	depth,
	groupId,
	issues,
}) => {
	let customComponents: CustomComponents | null = null;

	if (fg('jira_native_issue_table_extra_custom_components')) {
		// eslint-disable-next-line react-hooks/rules-of-hooks
		customComponents = useCustomComponents();
	}

	const issuesData = useFragment(
		graphql`
			fragment rowsAdditionalContentRenderer_nativeIssueTable on JiraIssueConnection
			@argumentDefinitions(isTimelineEnabled: { type: "Boolean!" }) {
				# eslint-disable-next-line @atlassian/relay/must-colocate-fragment-spreads
				...timelineRowsContent_issueTableTimeline @include(if: $isTimelineEnabled)
			}
		`,
		issues,
	);

	return (
		customComponents?.RowsAdditionalContent && (
			<customComponents.RowsAdditionalContent depth={depth} groupId={groupId} issues={issuesData} />
		)
	);
};
